"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _TitleCard = _interopRequireDefault(require("01_core/components/layout/TitleCard"));
var _ActionMessage = _interopRequireDefault(require("01_core/components/materials/ActionMessage"));
var _CButton = _interopRequireDefault(require("01_core/components/materials/CButton"));
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _CallAPI = require("01_core/components/system/CallAPI");
var _APIs = require("01_core/constants/APIs");
var _labelConsts = require("01_core/constants/labelConsts");
var _stringUtil = _interopRequireDefault(require("01_core/logics/stringUtil"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _CardContent = _interopRequireDefault(require("@mui/material/CardContent"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _styles = require("@mui/material/styles");
var _kansaReportActions = require("../kansaReportActions");
var _KansaReportChart = _interopRequireDefault(require("./components/KansaReportChart"));
var _KansaReportHeader = _interopRequireDefault(require("./components/KansaReportHeader"));
var _KansaReportSummary = _interopRequireDefault(require("./components/KansaReportSummary"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const WhiteSpaceTypography = (0, _styles.styled)(_Typography.default)({
  whiteSpace: 'pre-line'
});

/**
 * 監査報告書表示画面
 */
class KansaReportRefer extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "getCondition", condition => {
      const {
        kaishaSummary,
        kansaTgtNendo,
        hikansabumonKaishaCd,
        hikansabumonSoshikiCd
      } = this.props.targetReport;
      return {
        kaishaSummary: kaishaSummary,
        kansaTgtNendo: kansaTgtNendo,
        hikansabumonKaishaCd: hikansabumonKaishaCd,
        hikansabumonSoshikiCd: hikansabumonSoshikiCd,
        editable: false
      };
    });
    _defineProperty(this, "getEntries", condition => {
      const {
        callAPI,
        setEntries
      } = this.props;
      callAPI(_APIs.KANSA_REPORT_RP_REFER, condition).then(response => {
        if (response.status === _APIs.STATUS.SUCCESS) {
          setEntries(response.data);
        }
      });
    });
    let storageItem = this.props.referCondition;
    let _condition = storageItem ? JSON.parse(storageItem) : this.getCondition();
    this.getEntries(_condition);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  componentWillUnmount() {
    const {
      clearEntries
    } = this.props;
    clearEntries();
  }
  render() {
    const {
      intl,
      goMain,
      entries,
      dispContent,
      previousContent,
      openDetail,
      subContent,
      info
    } = this.props;
    const showResult = previousContent === _kansaReportActions.CONTENTS.REGISTER;
    const titleId = showResult ? _labelConsts.LABEL.KANSA_REPORT_REGISTER_RESULT : _labelConsts.LABEL.KANSA_REPORT_REFER;
    const returnBtn = /*#__PURE__*/_react.default.createElement(_CButton.default, {
      negative: true,
      autoWidth: true,
      onClick: () => {
        goMain(dispContent);
      }
    }, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_TO_RETURN_SEARCH_LIST
    }));
    const closeBtn = /*#__PURE__*/_react.default.createElement(_CButton.default, {
      negative: true,
      autoWidth: true,
      onClick: () => {
        window.close();
      }
    }, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_CLOSE
    }));
    return info.ready ? /*#__PURE__*/_react.default.createElement(_TitleCard.default, {
      title: intl.formatMessage({
        id: titleId
      }),
      actions: [subContent === _kansaReportActions.CONTENTS.REFER ? closeBtn : returnBtn]
    }, /*#__PURE__*/_react.default.createElement(_CardContent.default, null, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 1
    }, !entries ? /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, null, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_NO_DATA_TO_DISPLAY
    }))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, showResult && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 10
      }
    }, /*#__PURE__*/_react.default.createElement(_ActionMessage.default, {
      action: "register"
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 2
      },
      align: "right"
    }, subContent === _kansaReportActions.CONTENTS.REFER ? closeBtn : returnBtn), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_KansaReportHeader.default, {
      entries: entries
    }))), !showResult && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 10
      }
    }, /*#__PURE__*/_react.default.createElement(_KansaReportHeader.default, {
      entries: entries
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 2
      },
      align: "right"
    }, subContent === _kansaReportActions.CONTENTS.REFER ? closeBtn : returnBtn)), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_KansaReportSummary.default, {
      entries: entries,
      openDetail: openDetail
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_KansaReportChart.default, {
      entries: entries
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_KANSABUMON_COMMENT
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(WhiteSpaceTypography, null, _stringUtil.default.emptyToHyphen(entries.kansabumonComment)))))))) : null;
  }
}
const mapStateToProps = state => {
  return {
    targetReport: state.kansaReport.targetReport,
    entries: state.kansaReport.creation.entries,
    info: state.kansaReport.creation,
    dispContent: state.kansaReport.containerInfo.dispContent,
    previousContent: state.kansaReport.containerInfo.previousContent,
    subContent: state.kansaReport.containerInfo.subContent,
    referCondition: state.kansaReport.containerInfo.referCondition
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setEntries: entries => dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.SET_RP_ENTRIES](entries)),
    setSubwindow: value => dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.SET_SUBWINDOW](value)),
    goMain: previousContent => dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.GO_MAIN](previousContent)),
    clearEntries: () => dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.CLEAR_RP_ENTRIES]())
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)((0, _CallAPI.withCallAPI)(KansaReportRefer)));